import React from 'react';
import ReactPlayer from 'react-player';
import styled from 'styled-components';
//
export default React.memo(
  ({
    url,
    loop = true,
    muted = true,
    playsinline = true,
    playing = true,
    volume = 0
  }) => {
    if (!url) {
      return null;
    }

    const videoOptions = {
      height: 'auto',
      loop,
      muted,
      playing,
      playsinline,
      url,
      volume,
      width: '100%'
    };

    return (
      <Wrap>
        <ReactPlayer {...videoOptions} />
      </Wrap>
    );
  },
  (prev, next) => prev.url === next.url
);
//
const Wrap = styled.div`
  line-height: 0;
  pointer-events: none;
  width: 100%;
`;
